export interface IPageAndSheetToOpen
{
    page:string,
    sheet:string,
}

export class LocalStateUtil
{
    private static readonly WSP_SELECTED_PROJECT = 'wsp_selected_project';
    private static readonly WSP_SELECTED_PROJECT_ORGANIZATION = 'wsp_selected_project_organization';

    private static readonly WSP_PAGE_AND_SHEET_TO_OPEN = 'wsp_page_and_sheet_to_open';

    public static getSelectedProject(orgSid:string):number
    {
        let ls = window.localStorage;
        const storedOrgSid = ls.getItem(this.WSP_SELECTED_PROJECT_ORGANIZATION);
        if( orgSid !== storedOrgSid )
        {
            return null;
        }
        let selectedProjectString = ls.getItem(this.WSP_SELECTED_PROJECT);
        return /^\+?\d+$/.test(selectedProjectString) ? Number(selectedProjectString) : null;
    }

    public static storeSelectedProject(projectId:number, orgSid:string):void
    {
        let ls = window.localStorage;
        ls.setItem(this.WSP_SELECTED_PROJECT, projectId.toString());
        ls.setItem(this.WSP_SELECTED_PROJECT_ORGANIZATION, orgSid);
    }

    public static getPageAndSheetToOpen():IPageAndSheetToOpen
    {
        let ls = window.localStorage;
        const info:string = ls.getItem(this.WSP_PAGE_AND_SHEET_TO_OPEN);

        if (!info)
            return null;

        let result:IPageAndSheetToOpen = null;
        try
        {
            result = JSON.parse(info);
        }
        catch (e)
        {
            console.warn(`wrong value of ${LocalStateUtil.WSP_PAGE_AND_SHEET_TO_OPEN}, should contain 'page' and 'sheet' fields` )
        }

        return result;
    }

    public static storePageAndSheetToOpen(info:IPageAndSheetToOpen):void
    {
        let ls = window.localStorage;
        ls.setItem(this.WSP_PAGE_AND_SHEET_TO_OPEN, JSON.stringify(info));
    }

    public static clearPageAndSheetToOpen():void
    {
        let ls = window.localStorage;
        ls.removeItem(this.WSP_PAGE_AND_SHEET_TO_OPEN);
    }
}
